import { render, staticRenderFns } from "./agentAdmin.vue?vue&type=template&id=c168212a&scoped=true"
import script from "./agentAdmin.vue?vue&type=script&lang=js"
export * from "./agentAdmin.vue?vue&type=script&lang=js"
import style0 from "./agentAdmin.vue?vue&type=style&index=0&id=c168212a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168212a",
  null
  
)

export default component.exports